import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { imageUrl } from "../../lib/api";
import { imgSet } from "../../data/portfolio";
import { catLabel, nlDateLong } from "../../lib/kennisbank";

export const ArticleImage = ({ image, className = "", sizes = "(min-width: 1024px) 400px, 100vw", priority = false }) => (
  <img src={imageUrl(image?.path)} srcSet={imgSet(image?.path)} sizes={sizes} alt={image?.alt || ""} loading={priority ? "eager" : "lazy"}
    decoding={priority ? "sync" : "async"} className={`h-full w-full object-cover ${className}`} />
);

export const ArticleCard = ({ a, cats, testid }) => (
  <Link to={`/blog/${a.slug}`} className="card card-hover group flex h-full flex-col overflow-hidden" data-testid={testid || `kb-card-${a.slug}`}>
    <div className="aspect-[16/10] overflow-hidden bg-slate-100">
      <ArticleImage image={a.image} className="transition-transform duration-700 group-hover:scale-[1.03]" />
    </div>
    <div className="flex flex-1 flex-col p-5 sm:p-6">
      <p className="text-[12px] font-semibold uppercase tracking-[0.14em] text-gold">{catLabel(cats, a.category)}</p>
      <h3 className="mt-2 text-[18px] font-semibold leading-snug text-ink transition-colors group-hover:text-maas">{a.title}</h3>
      <p className="mt-2 line-clamp-3 flex-1 text-[14.5px] leading-relaxed text-slate-600">{a.excerpt}</p>
      <p className="mt-4 flex items-center gap-1.5 text-[13px] text-slate-500"><Clock className="h-3.5 w-3.5" aria-hidden="true" /> {a.read_minutes} min lezen · {nlDateLong(a.published_at)}</p>
    </div>
  </Link>
);

// Compacte regel voor smalle kolommen (offertewizard, zijkolom).
export const ArticleRow = ({ a, testid }) => (
  <Link to={`/blog/${a.slug}`} className="group flex items-center gap-4 rounded-xl p-2 transition-colors hover:bg-slate-50" data-testid={testid || `kb-row-${a.slug}`}>
    <span className="h-16 w-20 shrink-0 overflow-hidden rounded-lg bg-slate-100"><ArticleImage image={a.image} sizes="80px" /></span>
    <span className="min-w-0">
      <span className="block text-[15px] font-semibold leading-snug text-ink group-hover:text-maas">{a.title}</span>
      <span className="mt-1 block text-[13px] text-slate-500">{a.read_minutes} min lezen</span>
    </span>
  </Link>
);
